
export default {
    name: 'Checkbox',
    props: {
        value: {
            type: null,
            default: false
        }
    },
    data () {
        return {
            checked: !!this.value
        }
    },
    watch: {
        checked (checked) {
            this.$emit('input', checked)
        },
        value (value) {
            this.checked = value
        }
    },
    methods: {
        toggle () {
            this.checked = !this.checked
        }
    }
}
